import {
  EdgelessClipboardConfig,
  type PreparedEdgelessBlock,
} from '@blocksuite/affine-block-surface';
import { type BlockSnapshot } from '@blocksuite/store';

export class EdgelessClipboardEdgelessTextConfig extends EdgelessClipboardConfig {
  static override readonly key = 'affine:edgeless-text';

  override async prepareBlock(
    edgelessText: BlockSnapshot
  ): Promise<PreparedEdgelessBlock | null> {
    const oldId = edgelessText.id;
    delete edgelessText.props.index;
    if (!edgelessText.props.xywh) {
      console.error(
        `EdgelessText block(id: ${oldId}) does not have xywh property`
      );
      return null;
    }
    if (!this.surface) {
      return null;
    }
    const prepared = await this.prepareSnapshotPaste(
      edgelessText,
      this.std.store,
      this.surface.model.id
    );
    if (!prepared)
      console.error(`Failed to paste EdgelessText block(id: ${oldId})`);
    return prepared;
  }
}
